module.exports = __webpack_public_path__ + "static/media/noise.0ced52a5.png";